import Widget from '@/plugins/dashboard/widgets/Enquiries/Widget'
import Configure from '@/plugins/dashboard/widgets/Enquiries/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Enquiries'
  static widget = Widget
  static configure = Configure
}
